const timeDate = (date, current_date) =>{

    const currentDate = new Date(current_date)
    const postDate = new Date(date)
    const differente = (currentDate - postDate)/1000
    const absoluteDifference = Math.abs(Math.round(differente/60));

    if(absoluteDifference < 60){
        return `Hace ${Math.round(absoluteDifference)} minutos`
    }

    if(absoluteDifference >= 60 && absoluteDifference < (60*24)){
        return `Hace ${Math.round(absoluteDifference/60)} horas`
    }

    
    if(absoluteDifference >= (60*24)){
        return `Hace ${Math.round(absoluteDifference/(60*24))} días`
    }
}

export default timeDate